export default __webpack_public_path__ + "static/media/magic_tabby.76ae22cb.png";